import { FC, useState } from 'react';
import { Typography } from '../../../../core/components/molecules/Typography';
import { Button } from '../../../../core/components/atoms/Button';
import { Icon } from '../../../../core/components/atoms/Icon';
import { Modal } from '../../../../core/components/templates/Modal';
import { useNavigate, useParams } from 'react-router-dom';
import { IFeedback } from '../../../../core/models/essay';
import EssayPrint from '../../../../core/components/templates/PrintPaper/paper';
import NewPrintComponent from '../../../../core/components/organism/PrintComponent/newPrintComponent';

interface IRecycleButton {
  text: string;
  onClick: () => void;
  icon: string;
  disabled?: boolean;
}

interface IActionHeader {
  onReview: () => void;
  hasReview: boolean;
  feedback: IFeedback;
  canReview: boolean;
  canRedo?: boolean;
  hideReview?: boolean;
}

export function ActionHeader({
  onReview,
  hasReview,
  feedback,
  canReview,
  canRedo = true,
  hideReview = false,
}: IActionHeader) {
  const navigate = useNavigate();
  const { slug } = useParams();

  const [modalDownload, setModalDownload] = useState<boolean>(false);

  const RecycleButton: FC<IRecycleButton> = ({
    text,
    onClick,
    icon,
    disabled,
  }) => (
    <Button
      variant='outlined'
      full
      onClick={() => onClick()}
      disabled={disabled}
    >
      <Icon Icon={icon} type='material' variant='rounded' className='text-md' />
      <Typography size='small' className='uppercase'>
        {text}
      </Typography>
    </Button>
  );

  const handleRedo = () => {
    navigate('/redacoes/start/' + slug);
  };

  return (
    <div className='flex items-center gap-lg xs:flex-col lg:flex-row'>
      <NewPrintComponent
        type='paper'
        isOpen={modalDownload}
        onClose={() => setModalDownload(false)}
        title='Imprimir correção'
      >
        <EssayPrint feedback={feedback} />
      </NewPrintComponent>

      <RecycleButton
        text='Download da correção'
        onClick={() => setModalDownload(true)}
        icon='download_2'
      />
      {canRedo && (
        <RecycleButton
          text='Refazer redação'
          onClick={() => handleRedo()}
          icon='refresh'
        />
      )}
      {!hideReview && (
        <RecycleButton
          text='Avalie a correção'
          onClick={() => onReview()}
          icon='chat'
          disabled={hasReview || !canReview}
        />
      )}
    </div>
  );
}
